<template>
  <div>
    <menu-pages-navbar class="mb-3" />
    <v-layout
      class="mt-4"
      style="height: 100%; min-height: 480px"
    >
      <img
        style="width: 100%; height: auto; object-fit: contain"
        :src="explainFeatureImageUrl"
      >
    </v-layout>
  </div>
</template>

<script>
import MenuPagesNavbar from '@/components/Menu/MenuPagesNavbar';

export default {
  components: {
    MenuPagesNavbar,
  },
  data() {
    return {
      explainFeatureImageUrl:
        'https://cms.myshopradio.de/filer/canonical/1710146543/1108/',
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/MenuStart.vue